import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Diferenciador from "@/components/Diferenciador";
import Problema from "@/components/Problema";
import Lineas from "@/components/Lineas";
import Diferencias from "@/components/Diferencias";
import Beneficios from "@/components/Beneficios";
import ComoTrabajamos from "@/components/ComoTrabajamos";
import SobreNatacha from "@/components/SobreNatacha";
import Cierre from "@/components/Cierre";
import Footer from "@/components/Footer";
import SEO from "@/components/SEO";
import { Toaster } from "@/components/ui/sonner";

const Home = () => {
  return (
    <div>
      <SEO />
      <Navbar />
      <Hero />
      <Diferenciador />
      <Problema />
      <Lineas />
      <Diferencias />
      <Beneficios />
      <ComoTrabajamos />
      <SobreNatacha />
      <Cierre />
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
